export default "__VITE_ASSET__BXDF_aHt__"